var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.75C10.25 11.75 8 14 8 16.75V49.25C8 52 10.25 54.25 13 54.25H33C35.75 54.25 38 52 38 49.25V16.75C38 14 35.75 11.75 33 11.75",
    fill: "#673AB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.75H20.5V49.25H18V16.75ZM30.5 11.75V9.25C30.5 7.75 29.5 6.75 28 6.75H18C16.5 6.75 15.5 7.75 15.5 9.25V11.75H30.5Z",
    fill: "#311B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16.75H20.5V49.25H38V16.75ZM26.75 46.75H23V41.75H26.75V46.75ZM26.75 24.25H23V19.25H26.75V24.25ZM34.25 46.75H30.5V41.75H34.25V46.75ZM30.5 24.25V19.25H34.25V24.25H30.5Z",
    fill: "#D84315"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16.75V19.25H41.75V24.25H38V41.75H41.75V46.75H38V49.25H53V16.75H38ZM49.25 46.75H45.5V41.75H49.25V46.75ZM49.25 24.25H45.5V19.25H49.25V24.25Z",
    fill: "#FF5722"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory6);
export default __webpack_public_path__ + "static/media/category-6.2414a91be225d96f1a624544ca339efd.svg";
export { ForwardRef as ReactComponent };